/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Kaiserin_Friedrich_Gymnasium4Inputs */

const en__field__enum_schoolname_kaiserin_friedrich_gymnasium4 = /** @type {(inputs: _Field__Enum_Schoolname_Kaiserin_Friedrich_Gymnasium4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bad Homburg`)
};

const de__field__enum_schoolname_kaiserin_friedrich_gymnasium4 = /** @type {(inputs: _Field__Enum_Schoolname_Kaiserin_Friedrich_Gymnasium4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaiserin-Friedrich-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Bad Homburg" |
*
* @param {_Field__Enum_Schoolname_Kaiserin_Friedrich_Gymnasium4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_kaiserin_friedrich_gymnasium4 = /** @type {((inputs?: _Field__Enum_Schoolname_Kaiserin_Friedrich_Gymnasium4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Kaiserin_Friedrich_Gymnasium4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_kaiserin_friedrich_gymnasium4(inputs)
	return de__field__enum_schoolname_kaiserin_friedrich_gymnasium4(inputs)
});
export { _field__enum_schoolname_kaiserin_friedrich_gymnasium4 as "_field__enum_schoolName_Kaiserin_Friedrich_Gymnasium" }